<template>
  <a-modal
    v-model="visible"
    title="查看配方"
    width='900px'
    destroyOnClose
    :footer='false'
  >
    <a-tabs default-active-key="0">
      <a-tab-pane key="0" tab="原料">
        <RawMaterial :details="details" />
      </a-tab-pane>
      <a-tab-pane key="1" tab="营养分析">
        <NutritionalAnalysis :details="details" />
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>
<script>
import RawMaterial from './FormulaComponents/RawMaterial.vue';
import NutritionalAnalysis from './FormulaComponents/NutritionalAnalysis.vue';
export default {
  components:{RawMaterial,NutritionalAnalysis},
  data(){
    return {
      visible: false,
      details:{}
    }
  },

  methods: {
    init(record){
      this.visible = true
      this.details=record
    }
  }
}
</script>